import { OrganType } from '@nkr/enums/organ-type';
import ActionCenterNav from './nav';
import ToDo from './to-do';
import PendingSwaps from './pending-swaps';
import DataCompliance from './data-compliance';
import PreSelects from './pre-selects';
import CenterMoveTracker from './move-tracker';
import CenterRccap from '@nkr/views/rccap/center/rccap-response';
import RccapView from '@nkr/views/rccap/center/rccap-view';
import Tickets from '@nkr/views/ticketing/tickets/index';
import CreateCenterTicket from '@nkr/views/ticketing/ticket/center/create-center-ticket';
import ViewCenterTicket from '@nkr/views/ticketing/ticket/center/view-center-ticket';
import CenterPerformance from '@nkr/views/center-admin/action-center/center-performance';
import ExpertSystem from '@nkr/views/expert-system';
import HomeBloodDraw from '@nkr/views/home-blood-draw';
import ViewExpertSystemOrder from '@nkr/views/expert-system/view-order';
import XmTracking from '@nkr/views/xm-tracking';
import SerologyTracking from '@nkr/views/serology-tracking';
import StreamlinedSerology from '@nkr/views/home-blood-draw/streamlined-serology';
import HomeBloodDrawOrder from '@nkr/views/home-blood-draw/home-blood-order';
import PhlebotTracking from '@nkr/views/phlebot-tracking';
import SwapQualityIssueList from '@nkr/views/swap-quality-issues/list';
import SwapQualityIssueEdit from '@nkr/views/swap-quality-issues/edit';
import SwapQualityIssueNoIssue from '@nkr/views/swap-quality-issues/no-issue';
import OrderTracking from '@nkr/views/admin/order-tracking';

interface IProps {
    centerId: number,
    section: string,
    subSection: string,
    itemId?: number,
    zipCode?: string,
    donorShieldId?: string,
    inviteToDS?: string,
    isAdmin: boolean,
    organType: OrganType,
    lowPercentWarning: boolean
}

const ActionCenter = (props: IProps) => {
    const handleTabSelect = (key: string) => {
        window.location.href = '/center-admin/action-center/' + key;
    };

    const lowPercentWarning = props.lowPercentWarning;

    return (
        <div style={{ padding: 10 }}>
            <ActionCenterNav
                activeKey={props.section}
                centerId={props.centerId}
                itemId={props.itemId != null ? props.itemId : 0}
                isAdmin={props.isAdmin}
                onTabSelect={handleTabSelect}
            />

            <div style={{ width: '100%', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', borderBottom: '1px solid #ddd', minHeight: '80vh', paddingTop: 10, backgroundColor: '#FFF' }}>
                {props.section.toUpperCase() == 'TO-DO' && (
                    <ToDo
                        centerId={props.centerId}
                    />
                )}

                {props.section.toUpperCase() == 'PENDING-SWAPS' && (
                    <PendingSwaps
                        centerId={props.centerId}
                    />
                )}

                {props.section.toUpperCase() == 'DATA-COMPLIANCE' && (
                    <DataCompliance />
                )}

                {props.section.toUpperCase() == 'PRE-SELECTS' && (
                    <PreSelects />
                )}

                {props.section.toUpperCase() == 'MOVE-TRACKER' && (
                    <CenterMoveTracker
                        centerId={props.centerId}
                    />
                )}

                {props.section.toUpperCase() == 'RCCAP-RESPOND' && (
                    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <CenterRccap
                            id={props.itemId != null ? props.itemId : 0}
                            centerId={props.centerId}
                        />
                    </div>
                )}

                {props.section.toUpperCase() == 'RCCAP-VIEW' && (
                    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <RccapView
                            id={props.itemId != null ? props.itemId : 0}
                            centerId={props.centerId}
                        />
                    </div>
                )}

                {props.section.toUpperCase() == 'SUPPORT' && (
                    <Tickets centerId={props.centerId} isAdmin={false} />
                )}

                {props.section.toUpperCase() == 'CREATE-TICKET' && (
                    <CreateCenterTicket id={0} centerId={props.centerId} />
                )}

                {props.section.toUpperCase() == 'VIEW-TICKET' && (
                    <ViewCenterTicket id={props.itemId} centerId={props.centerId} />
                )}

                {props.section.toUpperCase() == 'CENTER-PERFORMANCE' && (
                    <CenterPerformance
                        centerId={props.centerId}
                    />
                )}

                {props.section.toUpperCase() == 'ORDER-TRACKING' && (
                    <OrderTracking
                        centerId={props.centerId}
                    />
                )}

                {props.section.toUpperCase() == 'HOME-BLOOD-DRAW' && (
                    <>
                        {props.subSection == 'ORDER' && (
                            <HomeBloodDrawOrder
                                centerId={props.centerId}
                                zipCode={props.zipCode}
                            />
                        )}

                        {props.subSection == 'STREAMLINED-SEROLOGY' && (
                            <StreamlinedSerology
                                centerId={props.centerId}
                                zipCode={props.zipCode}
                                donorShieldId={props.donorShieldId != null ? parseInt(props.donorShieldId) : null}
                                inviteToDS={props.inviteToDS != null ? parseInt(props.inviteToDS) == 1 : null}
                            />
                        )}

                        {props.subSection == '' && (
                            <HomeBloodDraw
                                centerId={props.centerId}
                            />
                        )}
                    </>
                )}

                {props.section.toUpperCase() == 'EXPERT-SYSTEM' && (
                    <>
                        {props.subSection == 'VIEW-ORDER' && (
                            <ViewExpertSystemOrder
                                centerId={props.centerId}
                                orderId={props.itemId}
                            />
                        )}

                        {props.subSection == '' && (
                            <ExpertSystem
                                centerId={props.centerId}
                                statusId={props.itemId}
                            />
                        )}
                    </>
                )}

                {props.section.toUpperCase() == 'XM-TRACKING' && (
                    <XmTracking centerId={props.centerId} tab={props.subSection} />
                )}

                {props.section.toUpperCase() == 'SEROLOGY-TRACKING' && (
                    <SerologyTracking centerId={props.centerId} tab={props.subSection} isAdmin={props.isAdmin} />
                )}

                {props.section.toUpperCase() == 'PHLEBOT-TRACKING' && (
                    <PhlebotTracking centerId={props.centerId} />
                )}

                {props.section.toUpperCase() == 'SWAP-QUALITY-ISSUES' && (
                    <SwapQualityIssueList centerId={props.centerId} isAdmin={false} />
                )}

                {props.section.toUpperCase() == 'SWAP-QUALITY-ISSUE' && (
                    <>
                        {props.subSection == 'EDIT' && (
                            <SwapQualityIssueEdit
                                centerId={props.centerId}
                                isAdmin={false}
                                viewOnly={false} />
                        )}

                        {props.subSection == 'VIEW' && (
                            <SwapQualityIssueEdit
                                centerId={props.centerId}
                                isAdmin={false}
                                viewOnly={true} />
                        )}

                        {props.subSection == 'NO-ISSUE' && (
                            <SwapQualityIssueNoIssue
                                centerId={props.centerId}
                                isAdmin={false} />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default ActionCenter;